/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { sortBy } from '@linc-technologies/linced-common/utils/arrays';
// Internal Imports

export default class PermissionReplyDetail extends Component {
  @service
  session;

  @service
  store;

  @service
  toaster;

  @tracked
  permissionReply = null;

  refresh() {}

  @tracked
  dialogOpen = false;

  @tracked
  editingField = '';

  @action
  setEditingField(value) {
    this.editingField = value;
  }

  @tracked
  selectedFields = [];

  @computed('permissionReply.{event.permissionFields.[],fieldsToUpdate.[]}')
  get updatablePermissionFields() {
    return this.permissionReply.event
      .get('permissionFields')
      .filter((field) =>
        this.permissionReply.fieldsToUpdate.includes(field.key),
      );
  }

  @computed(
    'permissionReply.{event.permissionFields.[],restrictedFieldsToUpdate.[]}',
  )
  get restrictedPermissionFields() {
    return this.permissionReply.event
      .get('permissionFields')
      .filter((field) =>
        this.permissionReply.restrictedFieldsToUpdate.includes(field.key),
      );
  }

  async save() {
    let newPermissionReply = this.store.createRecord(
      'events/permission-reply',
      {
        school: await this.permissionReply.school,
        event: await this.permissionReply.event,
        person: await this.permissionReply.person,
        author: this.get('session.person'),
        intentionToAttend: this.permissionReply.intentionToAttend,
        caregiverComment: this.permissionReply.caregiverComment,
        fieldsToUpdate: this.permissionReply.fieldsToUpdate.copy(),
        fieldsArray: this.permissionReply.fieldsArray.copy(),
      },
    );
    // Roll back attributes on the original once we copy them
    this.permissionReply.rollbackAttributes();
    this.permissionReply = newPermissionReply;
    this.permissionReply
      .save()
      .then(() => {
        this.editingField = '';
        // Refresh the list on the source component
        this.refresh();
        this.toaster.success('Permission Reply updated successfully!');
      })
      .catch(() => {
        this.toaster.error('Permission Reply update failed!');
      });
  }

  @action
  openDialog() {
    this.selectedFields = [];
    this.store
      .query('events/permission-reply', {
        schoolId: this.permissionReply.event.get('school.id'),
        eventId: this.permissionReply.event.get('id'),
        personId: this.permissionReply.person.get('id'),
      })
      .then((replies) => {
        if (replies.length) {
          this.permissionReply = sortBy(replies, 'createTime').reverse()[0];
        }
        this.dialogOpen = true;
        this.selectedFields = [];
        this.editingField = '';
      });
  }

  @action
  toggleFields(fields, checked) {
    let selectedFields = this.selectedFields;
    fields.forEach((field) => {
      if (checked) {
        if (!selectedFields.includes(field)) {
          selectedFields = [...selectedFields, field];
        }
      } else {
        selectedFields = selectedFields.filter((f) => f !== field);
      }
    });
    this.selectedFields = selectedFields;
  }

  @action
  saveEditingField() {
    this.save();
  }

  @action
  stopEditingField() {
    this.permissionReply.fields.get(this.editingField).rollbackAttributes();
    this.editingField = '';
  }

  @action
  toggleIntentionToAttend() {
    this.toggleProperty('permissionReply.intentionToAttend');
    this.save();
  }
}
